import * as React from 'react';
import { observer } from 'mobx-react';
import autobind from "autobind-decorator";
import { Button, Tabs, Breadcrumb, Icon, Col, Row } from 'antd';

import { DropdownView } from 'src/core/ui/dropdown.view';
import { resolve } from 'inversify-react';
import { RulesReflectionService } from 'src/app/rules/rules/rules.reflection.service';
import { TextView } from 'src/core/ui/text.view';
import { BooleanView } from 'src/core/ui/boolean.view';
import { UserEditorController } from 'src/app/general/users/parts/user-editor.controller';
import { DateView } from 'src/core/ui/date.view';
import { QuoteStatusChangeCondition } from '../form/parts/conditions/quote-condition-change-condition';
import { CheckEntityStatus } from '../form/parts/conditions/check-entity-status';
import { SendEmailExecutor } from 'src/app/rules/rules/form/parts/executors/send-email.executor';
import { GenerateInvoicesExecutor } from 'src/app/rules/rules/form/parts/executors/generate-invoice.executor';
import { WebHookExecutor } from 'src/app/rules/rules/form/parts/executors/call-webhook.executor';
import { SendInvoiceDocumentExecutor } from 'src/app/rules/rules/form/parts/executors/send-invoice-document';
import { BroadcastNotification } from 'src/app/rules/rules/form/parts/executors/broadcast-notification-executor';
import { observable } from 'mobx';
import { GatheringFromExternalToCacheExecutor } from 'src/app/rules/rules/form/parts/executors/gather-from-external-tocache.executor';
import { SendEmailExecutorEName, BroadcastMessageExecutorEName, GenerateInvoicesExecutorEName, WebhookExecutorEName, SendInvoiceDocumentsExecutorEName, AccommodationSearchExecutorEName, CarrentSearchExecutorEName, GeneralSearchExecutorEName, TransferSearchExecutorEName, GroupingUserTasksEmailExecutorEName } from 'src/app/rules/rules/parts/conditions';
import UserTaskGroupingExecutor from '../form/parts/executors/user-task-grouping.executor';


interface RulesExecutorEditorViewwProps {
	onChanged: (event: ConditionDefinitionItem) => void;
	onFieldChange: (propName: string, value: any) => void;
	fieldValues?: any;
	eventClasspath: string;
	eventWrapperName: string;
	event: PublicEventItem;
	value?: RuleDefinition;
	label: string;
	required?: boolean;
	mode: ControlMode;
	setBusy(isBusy: boolean);
}

@observer
export class RulesExecutorEditorView extends React.Component<RulesExecutorEditorViewwProps, {
	options: any[],
	item?: ConditionDefinitionItem,
	
}> {
	constructor(props) {
		super(props);

		this.state = {
			options: [],
			item: null
		}

		this.retryCount = 0;
		this.minInterval = 0;
		this.maxInterval = 0;
	}

	@resolve
	protected reflectionService: RulesReflectionService;

	@observable
	retryCount: number;

	@observable
	minInterval: number;

	@observable
	maxInterval: number;

	public componentWillReceiveProps(nextProps: RulesExecutorEditorViewwProps) {
		if ((nextProps.eventClasspath != this.props.eventClasspath) || nextProps.value != this.props.value) {
			this.request(nextProps);
		}
	}

	request(props: RulesExecutorEditorViewwProps) {

		this.reflectionService.getRuleExecutors(this.props.eventWrapperName).then(executors => {
			this.setState({ options: executors}, () => {

				if (props.value)
					var opt = this.state.options.find((value: ConditionDefinitionItem, index) => value.classPath === props.value.conditionDefinitionType);

				if (opt)
					this.setState({ item: opt });
			});
		});
	}

	public componentDidMount() {
		this.request(this.props);

		this.retryCount = this.props.value.retryCount || 0;
		this.maxInterval = this.props.value.maxRetryInterval || 0;
		this.minInterval = this.props.value.minRetryInterval || 0;
	}

	@autobind
	protected onEventSelect(item: any) {
		this.setState({ item });
		this.props.onChanged(item);
	}

	@autobind
	protected getEventFields(item: PublicEventItem) {
		return item ? item.properties: [];
	}
	

	private getConditionComponent(name: string) {

		const props = {
			mode: this.props.mode,
			values: this.props.value && this.props.value.conditionValues as any,
			onFieldChange: this.props.onFieldChange,
			event: this.props.event
		};

		switch (name) {

			case SendEmailExecutorEName:
				return <SendEmailExecutor {...props}
				/>

			case BroadcastMessageExecutorEName:
				return <BroadcastNotification {...props}/>

			case GenerateInvoicesExecutorEName:
				return <GenerateInvoicesExecutor {...props}
				/>;
			case WebhookExecutorEName:
				return <WebHookExecutor {...props}/>;

			case SendInvoiceDocumentsExecutorEName:
				return <SendInvoiceDocumentExecutor {...props} />;

			case AccommodationSearchExecutorEName:
				return <GatheringFromExternalToCacheExecutor {...props} searchType='Accommodation' />

			case CarrentSearchExecutorEName:
				return <GatheringFromExternalToCacheExecutor {...props} searchType='CarRent' />

			case GeneralSearchExecutorEName:
				return <GatheringFromExternalToCacheExecutor {...props} searchType='General' />

			case TransferSearchExecutorEName:
				return <GatheringFromExternalToCacheExecutor {...props} searchType='Transfer' />

			case GroupingUserTasksEmailExecutorEName:
				return <UserTaskGroupingExecutor {...props} />
				
		}

		return null;
	}

	@autobind
	private renderIntervals() {

		if (this.retryCount == 0)
			return null;

		var alhpa = Math.log2(this.maxInterval / this.minInterval) / this.retryCount;

		var times = [];

		for (var i = 0; i <= this.retryCount; i++) {
			var time = (this.minInterval * Math.pow(2, alhpa * i)).toFixed(0);
			times.push(<label>{time} mins, </label>);
		}

		return <p>Intervals: {times}</p>;
	}

	render() {
		let label = this.props.label;
		if (label === undefined) {
			label = 'Condition';
		}

		if (this.state.options.length < 1)
			return null;

		return (
			<React.Fragment>
				<Row>
					<Col xs={24} lg={8}>
						<DropdownView
							label={label}
							model={this.props.value ? this.props.value.conditionDefinitionType : ''}
							required={this.props.required}
							disabled={this.props.mode == 'display'}
							onChanged={this.onEventSelect}
							options={this.state.options}
							keyField='classPath'
							textField='name'
						/>
					</Col>
				</Row>
				{this.props.value && <Row gutter={24}>

					<Col xs={24} lg={8}>
						<TextView
							label="Retry count"
							value={this.retryCount}
							mode={this.props.mode}
							type='number'
							onChanged={e => {
								try {
									var value = Number.parseInt(e);
									this.props.value.retryCount = value;

									this.retryCount = value;
								}
								catch (c) {

								}
							}}
						/>
					</Col>
					<Col xs={24} lg={8}>
						<TextView
							label="Min retry interval (min)"
							value={this.minInterval}
							mode={this.props.mode}
							type='number'
							onChanged={e => {
								try {
									var value = Number.parseInt(e);
									this.props.value.minRetryInterval = value;

									this.minInterval = value;
								}
								catch (c) {

								}
							}}
						/>
					</Col>
					<Col xs={24} lg={8}>
						<TextView
							label="Max retry interval (min)"
							value={this.maxInterval}
							mode={this.props.mode}
							type='number'
							onChanged={e => {
								try {
									var value = Number.parseInt(e);
									this.props.value.maxRetryInterval = value;

									this.maxInterval = value
								}
								catch (c) {

								}
							}}
						/>
					</Col>
				</Row>}
				{this.props.value && <Row>
					{this.renderIntervals()}
				</Row>}
				<Row>
					<Col xs={24} lg={24} style={{marginTop: '10px'}} >
						{this.state.item && this.getConditionComponent(this.state.item.classPath)}
					</Col>
				</Row>
				</React.Fragment>);
	}
}



// WEBPACK FOOTER //
// ./src/app/rules/rules/parts/rules-executors.tsx